import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { "aria-label": "Page navigation" }
const _hoisted_2 = { class: "pagination justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-left" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "page-item"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "page-link" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-ellipsis-h" })
], -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "page-item"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "page-link" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-ellipsis-h" })
], -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right" }, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createCommentVNode(" Previous Button "),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabled: $props.currentPage === 1 }])
      }, [
        _createElementVNode("a", {
          class: "page-link",
          href: "#",
          "aria-label": "Previous",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.changePage($props.currentPage - 1)), ["prevent"]))
        }, _hoisted_4)
      ], 2 /* CLASS */),
      _createCommentVNode(" First Page Button (Always show) "),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { active: $props.currentPage === 1 }])
      }, [
        _createElementVNode("a", {
          class: "page-link",
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.changePage(1)), ["prevent"]))
        }, "1")
      ], 2 /* CLASS */),
      _createCommentVNode(" Ellipses before the current page group (if needed) "),
      ($options.showLeftEllipsis)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_7))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Page Numbers around the current page "),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visiblePages, (page) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["page-item", { active: $props.currentPage === page }]),
          key: page
        }, [
          _createElementVNode("a", {
            class: "page-link",
            href: "#",
            onClick: _withModifiers($event => ($options.changePage(page)), ["prevent"])
          }, _toDisplayString(page), 9 /* TEXT, PROPS */, _hoisted_8)
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */)),
      _createCommentVNode(" Ellipses after the current page group (if needed) "),
      ($options.showRightEllipsis)
        ? (_openBlock(), _createElementBlock("li", _hoisted_9, _hoisted_11))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Last Page Button (Always show) "),
      ($options.totalPages > 1)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            class: _normalizeClass(["page-item", { active: $props.currentPage === $options.totalPages }])
          }, [
            _createElementVNode("a", {
              class: "page-link",
              href: "#",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($options.changePage($options.totalPages)), ["prevent"]))
            }, _toDisplayString($options.totalPages), 1 /* TEXT */)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Next Button "),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabled: $props.currentPage === $options.totalPages }])
      }, [
        _createElementVNode("a", {
          class: "page-link",
          href: "#",
          "aria-label": "Next",
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($options.changePage($props.currentPage + 1)), ["prevent"]))
        }, _hoisted_13)
      ], 2 /* CLASS */)
    ])
  ]))
}